import { useQuery } from '@apollo/client';

import { useDegreeContext } from 'bundles/degree-home/components/v2/DegreeHomeContext';
import type {
  UseStudentSuccessAttributesQuery as UseStudentSuccessAttributesQueryData,
  UseStudentSuccessAttributesQueryVariables,
} from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/useStudentSuccessAttributes';
import UseStudentSuccessAttributesQuery from 'bundles/degree-home/components/v3-dpm/lib/__queries__/useStudentSuccessAttributes.graphql';

const useStudentSuccessAttributes = () => {
  const { degreeId } = useDegreeContext();

  const variables: UseStudentSuccessAttributesQueryVariables = {
    degreeId,
  };

  const { data } = useQuery<UseStudentSuccessAttributesQueryData, UseStudentSuccessAttributesQueryVariables>(
    UseStudentSuccessAttributesQuery,
    {
      variables,
      context: { clientName: 'gatewayGql' },
    }
  );

  return {
    studentSuccessAttributes: data?.Degree?.queryById?.studentSuccessAttributes,
  };
};

export default useStudentSuccessAttributes;
